import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  exercisesListSearch: {
    marginBottom: theme.spacing(1),
  },
  filtersRow: {
    marginBottom: theme.spacing(1),
  },
}));
